export default {
  SET_FULL_REPORT_COLUMNS(state, payload) {
    state.fullReportColumns = payload
  }
}
